<template>
  <div>
    <base-data-table
      :loading="isLoading"
      :options.sync="options"
      :headers="headers"
      :items="transactions.data"
      :serverItemsLength="transactions.total"
      :nbItemsByPage="NB_ITEMS_BY_PAGE"
      containerId="#table-cbs-container"
      itemClickRouterTarget="groupe-details"
      :fixedHeaders="fixedHeaders"
      :click-on-row="false"
    >
      <template v-slot:item.realDate="{ item }">{{
        getInternationalDate(item.realDate)
      }}</template>
      <template v-slot:item.updatedAt="{ item }">{{
        getInternationalDate(item.updatedAt)
      }}</template>

      <template v-slot:item.client="{ item }">
        <router-link
          v-if="item.client != null && item.client.id != null"
          :to="{
            name: 'portail-details',
            params: { id: item.client.id },
          }"
          >{{ item.client.description }}
        </router-link>
        <span v-else-if="item.client != null">
          {{ item.client.passmanId }}
        </span>
      </template>

      <template v-slot:item.amount="{ item }">
        <span v-if="item.amount != null && item.amount != 0">
          {{ item.amount / 100 }}
        </span>
        {{ item.currency }}
      </template>

      <template v-slot:item.paymentCallback="{ item }">
        <span v-if="item.paymentCallback == '00'"> OK </span>
        <span v-else> NON_RECU </span>
        ({{ item.paymentCallback }})
      </template>

      <template v-slot:item.login="{ item }">
        <router-link
          v-if="item.login != null"
          :to="{
            name: 'cartes-details',
            params: { id: item.login },
          }"
          >{{ item.login }}
        </router-link>
      </template>
    </base-data-table>
  </div>
</template>
<script>
import { date } from "@/composables/date";
import { onMounted, toRefs, watch } from "@vue/composition-api";
import { useCbTransaction } from "../../composables/cb-transaction";
import BaseDataTable from "@/components/General/BaseDataTable.vue";

export default {
  components: {
    BaseDataTable,
  },
  props: {
    clientPortal: Object,
    filterParams: Object,
    fixedHeaders: { type: Boolean, default: true },
  },
  setup(props) {
    /* Import des API */
    const { getInternationalDate } = date();
    const { data, listCBTransactions } = useCbTransaction();

    /* Variables */
    const NB_ITEMS_BY_PAGE = 100;

    /* Watchers */
    watch(
      [() => data.options, () => props.filterParams],
      (newValue, oldValues) => {
        if (oldValues[0].page !== undefined) {
          listCBTransactions(props.clientPortal, props.filterParams);
        }
      },
      {
        deep: true,
      }
    );

    /* Cycle de vie */
    onMounted(() => {
      listCBTransactions(props.clientPortal, props.filterParams);
    });

    return {
      ...toRefs(data),
      getInternationalDate,
      headers: [
        { text: "Client", value: "client" },
        { text: "Num Facture", value: "bill" },
        { text: "Date", value: "realDate" },
        { text: "CC Num", value: "numCb" },

        { text: "Montant", value: "amount" },
        { text: "Confirm. client", value: "clientConfirm" },
        { text: "Etat serveur", value: "paymentCallback" },
        { text: "Produit", value: "product" },
        { text: "Email", value: "email" },
        { text: "Login", value: "login" },
        { text: "Password", value: "password" },
        { text: "Trans.ID", value: "transactionId" },
        { text: "Marchand", value: "merchant" },
      ],
      NB_ITEMS_BY_PAGE,
    };
  },
};
</script>
